import { createContext, useState } from "react";
import { Outlet, ScrollRestoration } from "react-router-dom";
import './App.css';
import NavBar from './components/NavBar';
import { dateToString } from "./helper/utils";

export const NavbarDateContext = createContext();

function App() {
  const [navbarDate, setNavbarDate] = useState(dateToString(new Date()));

  return (
    <div className="App">
      <ScrollRestoration />
      <NavBar navbarDate={navbarDate} />
      <div className="body-container">
        <NavbarDateContext.Provider value={{navbarDate, setNavbarDate}}>
          <Outlet />
        </NavbarDateContext.Provider>
      </div>
    </div>
  );
}

export default App;
